import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, notification, Form, Space,Tooltip,Modal,Input } from "antd";
import GenericTable from "../components/GenericTable";
import GenericDrawer from "../components/GenericModal";
import GenericViewModal from "../components/GenericViewModal";
import {
  fetchEncountersRequest,
  createEncounterRequest,
  updateEncounterRequest,
  deleteEncounterRequest,
} from "../redux-saga/actions/encounterActions";
import { useParams } from "react-router-dom";
import ProjectNavbar from "../components/ProjectNavbar";
import { updateCurrentProjectId } from "../redux-saga/actions/customerActions";
import moment from "moment";
import {fetchVisitsRequest}  from "../redux-saga/actions/visitActions";
import { options } from "less";
import {fetchPhysiciansRequest} from "../redux-saga/actions/physicianActions";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import {IconMoodSearch} from '@tabler/icons-react';



const EncounterPage = () => {
  const dispatch = useDispatch();
  const { projectId } = useParams();
  const encounters = useSelector((state) => state.encounter.encounters?.data);
  const loading = useSelector((state) => state.encounter.loading);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingEncounter, setEditingEncounter] = useState(null);
  const [form] = Form.useForm();
  const [viewingEncounter, setViewingEncounter] = useState(null);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const visits = useSelector((state) => state.visit.visits?.data);
  const physicians = useSelector((state) => state.physician.physicians?.data);

  const metaData = useSelector((state) => state.encounter.encounters?.meta || {});
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  
  useEffect(() => {
    dispatch(fetchEncountersRequest(projectId,{ page: currentPage, limit: 2, search: searchTerm }));
    dispatch(updateCurrentProjectId(projectId));
    dispatch(fetchVisitsRequest(projectId));
    dispatch(fetchPhysiciansRequest(projectId));
  }, [dispatch, projectId,currentPage, searchTerm]);
  

  const encounterModalInputs = [
    { label: "Place of Incident", name: "placeOfIncident", type: "text" },
    { label: "Date of Occurrence", name: "dateOfOccurance", type: "date" },
    { label: "Place of Service", name: "placeOfService", type: "text" },
    { label: "Date of Service (DOS)", name: "DOS", type: "date" },
    { label: "Visit ID", name: "visitId", type: "select" ,options: visits?.map((visit) => ({
      label: visit.name,
      value: visit.id,
    })), },
    { label: "Physician ID", name: "physicianId", type: "select",options: physicians?.map((physician) => ({
      label: physician.name,
      value: physician.id,
    })), },
  ];

  const handleCreateOrEdit = (values) => {
    const payload = {
      ...values,
      dateOfOccurance: values.dateOfOccurance ? moment(values.dateOfOccurance).format("YYYY-MM-DD") : null,
      DOS: values.DOS ? moment(values.DOS).format("YYYY-MM-DD") : null,
    };
  
    if (editingEncounter) {
      dispatch(updateEncounterRequest(editingEncounter.id, payload, projectId));
    } else {
      dispatch(createEncounterRequest(payload, projectId));
    }
  
    notification.success({ message: "Success", description: "Encounter saved successfully." });
    setIsModalVisible(false);
    setEditingEncounter(null);
    form.resetFields();
  };
  

  const handleView = (record) => {
    const formattedRecord = {
      ...record,
      createdAt: record.createdAt ? moment(record.createdAt).format("YYYY-MM-DD HH:mm:ss") : null,
      updatedAt: record.updatedAt ? moment(record.updatedAt).format("YYYY-MM-DD HH:mm:ss") : null,
    };
    setViewingEncounter(formattedRecord);
    setIsViewModalVisible(true);
  };

  const handleEdit = (record) => {
    const formattedRecord = {
      ...record,
      dateOfOccurance: record.dateOfOccurance ? moment(record.dateOfOccurance) : null,
      DOS: record.DOS ? moment(record.DOS) : null,
    };
    setEditingEncounter(formattedRecord);
    setIsModalVisible(true);
    form.setFieldsValue(formattedRecord);
  };
  

  const handleDelete = (record) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this encounter?',
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        dispatch(deleteEncounterRequest(record.id, projectId));
        notification.success({ message: "Deleted", description: "Encounter deleted successfully." });
      }
    });
  };

  const columnsConfig = [
    { title: "Place of Incident", dataIndex: "placeOfIncident" },
    { title: "Date of Occurrence", dataIndex: "dateOfOccurance" },
    { title: "Place of Service", dataIndex: "placeOfService" },
    { title: "Date of Service (DOS)", dataIndex: "DOS" },
    // { title: "Visit ID", dataIndex: "visitId" },
    // { title: "Physician ID", dataIndex: "physicianId" },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="View">
            <EyeOutlined style={{ fontSize: "20px", color: "#1890ff" }} onClick={() => handleView(record)} />
          </Tooltip>
          <Tooltip title="Edit">
            <EditOutlined style={{ fontSize: "20px", color: "#faad14" }} onClick={() => handleEdit(record)} />
          </Tooltip>
          <Tooltip title="Delete">
            <DeleteOutlined style={{ fontSize: "20px", color: "#f5222d" }} onClick={() => handleDelete(record)} />
          </Tooltip>
        </Space>
      ),
    },
  ];


  return (
    <div style={{display:"flex",gap:"10px"}}>
      <ProjectNavbar />
      <div style={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px" }}>
              <IconMoodSearch style={{ fontSize: "24px", color: "black" }} />
                <h2 style={{ margin: 0 }}>Encounter</h2>
            </div>

            <div style={{ display: "flex", justifyContent: "end", marginBottom: 11 }}>
              <Button type="primary" onClick={() => setIsModalVisible(true)}>
                Create Encounter
              </Button>
            </div>
        </div>
        <Input
          placeholder="Search Encounter"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginBottom: "16px" }}
        />
      <GenericTable data={encounters} columnsConfig={columnsConfig}  loading={loading}
      pagination={{
        current: metaData.page || 1,
        pageSize: metaData.limit || 2,
        total: metaData.total || 0,
         onChange: (page, pageSize) => {
          setCurrentPage(page);
          dispatch(fetchEncountersRequest({ page, limit: pageSize, search: searchTerm }));
        },
      }} />
      {isModalVisible && (
          <GenericDrawer
            isVisible={isModalVisible}
            handleCancel={() => {
              setIsModalVisible(false);
              setEditingEncounter(null);
            }}
            title={
              <span style={{display : "flex",alignItems:"center"}}>
                <IconMoodSearch style={{ color: "white", marginRight: "8px" }} />
                {editingEncounter ? "Edit Encounter" : "Create Encounter"}
              </span>
            }
            inputs={encounterModalInputs}
            onSubmit={handleCreateOrEdit}
            predefinedData={editingEncounter || {}}
          />
        )}
      {isViewModalVisible && (
        <GenericViewModal
          isVisible={isViewModalVisible}
          handleCancel={() => setIsViewModalVisible(false)}
          title="View Encounter"
          data={viewingEncounter}
          footerButtons={["Close"]}
          onButtonClick={() => setIsViewModalVisible(false)}
        />
      )}
      </div>
    </div>
  );
};

export default EncounterPage;
